var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/navigation-items.j2"] = require( "macros/navigation-items.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/footer/language-links.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/navigation-items.j2", false, "core/templates/footer/language-links.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("renderNavItem")) {
var t_4 = t_1.renderNavItem;
} else {
cb(new Error("cannot import 'renderNavItem'")); return;
}
context.setVariable("renderNavItem", t_4);
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"footerNavigation")) {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"footerNavigation")),"sites")) {
output += "<ul class=\"c-language-links__ul u-clearfix\">";
frame = frame.push();
var t_7 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"footerNavigation")),"sites")),"childSlugs");
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("childSlug", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += runtime.suppressValue((lineno = 6, colno = 57, runtime.callWrap(t_4, "renderNavItem", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_8),runtime.makeKeywordArgs({"caller": (function (){var macro_t_9 = runtime.makeMacro(
["navItem", "url", "target"], 
[], 
function (l_navItem, l_url, l_target, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("navItem", l_navItem);
frame.set("url", l_url);
frame.set("target", l_target);
var t_10 = "";t_10 += "\n\n                    ";
var t_11;
t_11 = "noopener noreferrer";
frame.set("rel", t_11, true);
if(frame.topLevel) {
context.setVariable("rel", t_11);
}
if(frame.topLevel) {
context.addExport("rel", t_11);
}
t_10 += "\n\n                    <li class=\"c-language-links__li u-adjacent-divider\">\n                        ";
if(runtime.memberLookup((l_navItem),"displayName") == "UK") {
var t_12;
t_12 = "<abbr title=\"United Kingdom\">" + "" + runtime.memberLookup((l_navItem),"displayName") + "" + "</abbr>";
frame.set("languageLinkTitle", t_12, true);
if(frame.topLevel) {
context.setVariable("languageLinkTitle", t_12);
}
if(frame.topLevel) {
context.addExport("languageLinkTitle", t_12);
}
;
}
else {
if(runtime.memberLookup((l_navItem),"displayName") == "US") {
var t_13;
t_13 = "<abbr title=\"United States\">" + "" + runtime.memberLookup((l_navItem),"displayName") + "" + "</abbr>";
frame.set("languageLinkTitle", t_13, true);
if(frame.topLevel) {
context.setVariable("languageLinkTitle", t_13);
}
if(frame.topLevel) {
context.addExport("languageLinkTitle", t_13);
}
;
}
else {
var t_14;
t_14 = runtime.memberLookup((l_navItem),"displayName");
frame.set("languageLinkTitle", t_14, true);
if(frame.topLevel) {
context.setVariable("languageLinkTitle", t_14);
}
if(frame.topLevel) {
context.addExport("languageLinkTitle", t_14);
}
;
}
;
}
var t_15;
t_15 = (runtime.inOperator("?",l_url)?"&":"?");
frame.set("querySeperator", t_15, true);
if(frame.topLevel) {
context.setVariable("querySeperator", t_15);
}
if(frame.topLevel) {
context.addExport("querySeperator", t_15);
}
t_10 += "\n\n                        <a ";
t_10 += runtime.suppressValue((lineno = 21, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["footer","international",runtime.memberLookup((l_navItem),"slug")])), env.opts.autoescape);
t_10 += " ";
if(l_target) {
t_10 += " target=\"";
t_10 += runtime.suppressValue(l_target, env.opts.autoescape);
t_10 += "\" ";
if(l_target == "_blank") {
t_10 += " rel=\"";
t_10 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "rel"), env.opts.autoescape);
t_10 += "\" ";
;
}
t_10 += " ";
;
}
t_10 += " href=\"";
t_10 += runtime.suppressValue(env.getFilter("sanitize_url").call(context, (l_url + "" + "/")), env.opts.autoescape);
t_10 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "querySeperator"), env.opts.autoescape);
t_10 += "ref=footer\" data-locale-url=\"";
t_10 += runtime.suppressValue(l_url, env.opts.autoescape);
t_10 += "\" class=\"c-language-links__a js-site-language-change\" data-qa-footer-site-nav-slug=\"";
t_10 += runtime.suppressValue(runtime.memberLookup((l_navItem),"slug"), env.opts.autoescape);
t_10 += "\">\n                            ";
t_10 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "languageLinkTitle")), env.opts.autoescape);
t_10 += "\n                        </a>\n\n                    </li>\n                ";
;
frame = frame.pop();
return new runtime.SafeString(t_10);
});
return macro_t_9;})()})])), env.opts.autoescape);
;
}
}
frame = frame.pop();
output += "</ul>";
;
}
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/footer/language-links.j2"] , dependencies)